import { type ReactNode, createContext, useMemo } from 'react'

import { env } from '@/env'

export type AppConfig = {
  nats: {
    wsUrl: string
    user: string
    password: string
  }
  misc: {
    enableMSW: boolean
  }
  auth: {
    enableAuth: boolean
    authority: string
    clientId?: string
  }
}

export const defaultConfig: AppConfig = {
  nats: {
    wsUrl: env.VITE_NATS_WS_URL,
    user: env.VITE_NATS_USER,
    password: env.VITE_NATS_PASSWORD,
  },
  misc: {
    enableMSW: env.VITE_ENABLE_MSW,
  },
  auth: {
    enableAuth: env.VITE_AUTH_ENABLED,
    authority: env.VITE_AUTH_AUTHORITY,
    clientId: env.VITE_AUTH_CLIENT_ID,
  },
}

export const ConfigContext = createContext<AppConfig>(defaultConfig)

export type ConfigProviderProps = {
  children: ReactNode
  overrideConfig?: Partial<AppConfig>
}

export const ConfigProvider = ({
  children,
  overrideConfig,
}: ConfigProviderProps) => {
  const mergedConfig = useMemo(
    () => ({ ...defaultConfig, ...overrideConfig }),
    [overrideConfig],
  )

  return (
    <ConfigContext.Provider value={mergedConfig}>
      {children}
    </ConfigContext.Provider>
  )
}
